import { render, staticRenderFns } from "./notSoldApartments.vue?vue&type=template&id=7fc8c8cd&"
import script from "./notSoldApartments.vue?vue&type=script&lang=js&"
export * from "./notSoldApartments.vue?vue&type=script&lang=js&"
import style0 from "./notSoldApartments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports